export default {
  icons:[
    'at',
    'atom',
    'award',
    'backpack',
    //"badge-check",
    //"bank",
    //"bell",
    'bitcoin',
    'bolt',
    'bone',
    //"book-alt",
    'book-open-text',
    //"bookmark",
    //"books",
    'briefcase',
    'brush-alt',
    'bug',
    //"cabinet-filing",
    'cake',
    'calculator-simple',
    //"calendar",
    'camera',
    'castle',
    //"chart-line-up",
    'chart-pie',
    'chromecast',
    //"clipboard-edit",
    'clock',
    //"cloud-download",
    'cloud',
    'code',
    'coin',
    //"comment-text",
    'comments-text',
    'compass',
    //"copy2right-circle",
    'crown',
    'delivery-cart',
    'desktop',
    'disc',
    'dna',
    'dollar',
    //"edit",
    'ethereum',
    'euro',
    //"exchange-horizontal-circle",
    //"file-text",
    //"file",
    'film',
    'fire',
    //"flag-triangle",
    'flask',
    //"folder-open",
    'food-tray',
    'game-controller',
    'gift',
    'glasses',
    'globe-earth',
    'graduation-cap',
    'hashtag',
    'headphones',
    'heart',
    'home-dollar',
    //"home",
    'hourglass',
    //"id-card",
    'image',
    'key',
    'keyboard',
    //"keyhole-circle",
    'leaf',
    'life-ring',
    'light-emergency',
    'lightbulb',
    'like',
    //"list",
    //"location-crosshairs",
    'location-pin',
    //"lock",
    'magnet',
    //"map-location",
    'map-pin',
    'map',
    //"maximize",
    'medal',
    'megaphone',
    'microphone-stand',
    'microphone',
    'microscope',
    //"minimize",
    'mosque',
    'mug',
    'music',
    'newspaper',
    'palette',
    'pen-line',
    'pen-tool',
    'percent',
    'phone',
    'pills',
    'play-circle',
    'power-off-circle',
    'presentation',
    'puzzle',
    //"question-circle",
    'radiation',
    'radio',
    'ranking',
    'restaurant',
    'road',
    //"rotate-right-square",
    'school',
    'scissors',
    'search',
    'settings',
    'shield',
    //"shopping-bag-alt",
    'shopping-basket',
    'shopping-cart',
    //"signs-direction",
    //"sliders-vertical",
    'sparkle',
    'speaker',
    'star',
    'stethoscope',
    'stopwatch',
    'store',
    'sun',
    'tag',
    'target',
    'telescope',
    'thumbtack',
    //"time-forward",
    //"time-past",
    'tool',
    'tooth',
    'trash',
    'tree',
    //"triangle-exclamation",
    'trophy',
    'truck',
    'tv-retro',
    //"users-alt",
    //"users-group-alt",
    'video-play',
    'video',
    'volume-high',
    'watch-square',
  ]
};